import { withField, withRow } from 'components/InputsUtils';
import { WrappedInputProps } from 'components/InputsUtils/types';
import Select from './Select';

export default withRow(withField<WrappedInputProps>(Select));
